import { render, staticRenderFns } from "./rezervasyonYazdir.vue?vue&type=template&id=44b94617&scoped=true"
import script from "./rezervasyonYazdir.vue?vue&type=script&lang=js"
export * from "./rezervasyonYazdir.vue?vue&type=script&lang=js"
import style0 from "./rezervasyonYazdir.vue?vue&type=style&index=0&id=44b94617&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b94617",
  null
  
)

export default component.exports